module.exports = __webpack_public_path__ + "static/media/Pil.04ba4f7e.PNG";